export const cleanObjectProperties = (obj, value) => {
  const newObject = { ...obj };

  Object.keys(newObject).forEach((key) => {
    if (newObject[key] === value) {
      delete newObject[key];
    }
  });

  return newObject;
};
